import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './auth/login/login.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetComponent } from './auth/reset/reset.component';

import { TechnicianDetailsComponent } from './auth/technician-details/technician-details.component';
import { AuthGurdService } from './auth-gurd/auth-gurd.service';

const routes: Routes = [
    { 
      path: '', 
      redirectTo: '/login', 
      pathMatch: 'full' 
    },
    { 
      path: 'login',
      component: LoginComponent, 
      data: { pageTitle: 'Login' } 
    },
    { 
      path: 'forgot-password', 
      component: ForgotPasswordComponent, 
      data: { pageTitle: 'Forgot Password' } 
    },{ 
      path: 'reset', 
      component: ResetComponent, 
      data: { pageTitle: 'Reset Password' } 
    },
    { 
      path: 'updates', 
      loadChildren: () => import('./components/updates/updates.module').then(m => m.UpdatesRoutesModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['isp','admin','asm','rsm','ho']
      }
    },
    { 
      path: 'technicians-analytics', 
      loadChildren: () => import('./components/technicians-analytics/technicians-analytics.module').then(m => m.TechniciansAnalyticsRoutesModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['admin','isp','asm','rsm']
      }
    },
    { 
      path: 'order-list', 
      loadChildren: () => import('./components/order-list/order-list.module').then(m => m.OrderListRoutesModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['admin','isp','ho']
      }
    },
    { 
      path: 'technicians-list', 
      loadChildren: () => import('./components/technicians-list/technicians-list.module').then(m => m.TechniciansRoutesModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['admin','isp','ho','bo','asm','rsm']
      }
    },
   
    
    { 
      path: 'job-orders', 
      loadChildren: () => import('./components/job-orders/job-orders.module').then(m => m.JobOrdersModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['isp','admin','ho','asm','rsm','bo']
      }
    },
    { 
      path: 'user', 
      loadChildren: () => import('./components/user/user.module').then(m => m.UserModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['isp','admin','bo','asm','rsm','ho']
      }
    },
    { 
      path: 'order', 
      loadChildren: () => import('./components/order/order.module').then(m => m.OrderModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['isp','admin','bo','ho']
      }
    },
    {
      path: 'admin',
      loadChildren: () => import('./components/admin/admin.module').then(m => m.AdminModule),
      canActivate: [AuthGurdService]
    },
    {
      path: 'branch-code',
      loadChildren: () => import('./components/branch-code/branch-code.module').then(m => m.BranchCodeRoutesModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['admin','ho']
      }
    },
    {
      path: 'isps',
      loadChildren: () => import('./components/isps/isps.module').then(m => m.IspsRoutesModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['admin', 'bo', 'ho','asm','rsm']
      }
    }, 
    {
      path: 'reports',
      loadChildren: () => import('./components/report/report.module').then(m => m.ReportRoutesModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['admin', 'bo', 'ho','asm','rsm']
      }
    },
    { 
      path: 'asm-list', 
      loadChildren: () => import('./components/asm-list/asm-list.module').then(m => m.ASMRoutesModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['admin','asm','rsm', 'ho']
      }
    },
  
    { 
      path: 'whuser', 
      loadChildren: () => import('./components/whuser/whuser.module').then(m => m.WHUserModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['admin','asm','rsm', 'ho']
      }
    },
{
      path: 'bsm-list', 
      loadChildren: () => import('./components/bsm-list/bsm-list.module').then(m => m.BSMRoutesModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['admin']
      }
    },
    { 
      path: 'rsm-list', 
      loadChildren: () => import('./components/rsm-list/rsm-list.module').then(m => m.RSMRoutesModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['admin', 'ho']
     }
    },
    { 
      path: 'ho-list', 
      loadChildren: () => import('./components/ho-list/ho-list.module').then(m => m.HORoutesModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['admin']
     }
    },
    { 
      path: 'bo-list', 
      loadChildren: () => import('./components/bo-list/bo-list.module').then(m => m.BORoutesModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['admin', 'ho']
     }
    },
    {
      path: 'technicians',
      loadChildren: () => import('./components/technicians/technicians.module').then(m => m.TechniciansModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['admin', 'isp', 'ho','asm','rsm']
      }
    },
    {
      path: 'branch-office',
      loadChildren: () => import('./components/zones/zone.module').then(m => m.ZoneModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['admin', 'bo', 'ho']
      }
    },
    {
      path: 'dealers',
      loadChildren: () => import('./components/dealers/dealers.module').then(m => m.DealersModule),
      canActivate: [AuthGurdService]
    },
    {
      path: 'user-list',
      loadChildren: () => import('./components/users-list/users-list.module').then(m => m.UsersListModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['admin', 'bo', 'ho']
      }
    },
    {
      path: 'chat-room',
      loadChildren: () => import('./components/chat-room/chat-room.module').then(m => m.ChatRoomModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['isp']
      }
    },
    { 
      path: 'tech-allocation', 
      loadChildren: () => import('./components/tech-allocation/tech-allocation.module').then(m => m.TechAllocationModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['isp']
      }
    },
  
    { 
      path: 'returnofthespares', 
      loadChildren: () => import('./components/returnofthespares/returnofthespares.module').then(m => m.ReturnOftheSparModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['isp','whuser','admin']
      }
    },
    { 
      path: 'viewofreceivesparepart', 
      loadChildren: () => import('./components/viewofreceivesparepart/viewofreceivesparepart.module').then(m => m.ViewOfReceiveSparePartModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['isp','whuser','admin','bo','asm','rsm','ho']
      }
    },
    { 
      path: 'service-orders', 
      loadChildren: () => import('./components/mis/mis.module').then(m => m.MisModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['admin','isp','bo', 'ho','asm','rsm']
      }
    },
    { 
      path: 'dashboard', 
      loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardRoutesModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: ['isps','hos','asms','rsms','bsms']
     }
    },
    {
      path: 'upload-download',
      loadChildren: () => import('./components/upload-download/upload-download.module').then(m => m.UploadDownloadModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: [ 'hos']
      }
    },  
    {
      path: 'upload-user',
      loadChildren: () => import('./components/upload-user/upload-user.module').then(m => m.UploadUserModule),
      canActivate: [AuthGurdService],
      data: {
        allowedRoles: [ 'hos']
      }
    }, 
    { 
      path: 'details/:id', 
      component: TechnicianDetailsComponent, 
      data: { pageTitle: 'Technician Details' } 
    },
    {
      path: '**',
      redirectTo: '/login'
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
